import _ from 'lodash';

import { removeExcessiveSpaces } from 'utils/string';

const DEFAULT_SORT_FIELD = 'name';

export const sortTreeAlphabetically = (tree, sortBy) => {
  const getSortKey = _.isFunction(sortBy)
    ? sortBy
    : item => _.get(item, _.isString(sortBy) ? sortBy : DEFAULT_SORT_FIELD);

  const sortLevel = nodes =>
    _.orderBy(nodes, node => removeExcessiveSpaces(_.toLower(getSortKey(node))), 'asc').map(node =>
      node.nestedFields ? { ...node, nestedFields: sortLevel(node.nestedFields) } : node,
    );

  return sortLevel(tree);
};

export const makeTree = (data, formatTreeItems) => {
  const deepCloned = _.cloneDeep(data);
  const groupedByParents = _.groupBy(deepCloned, 'parentId');
  const mappedById = _.keyBy(deepCloned, 'id');

  _.each(_.omit(groupedByParents, 'null'), (children, parentId) => {
    const nestedFields = _.isFunction(formatTreeItems) ? formatTreeItems(children) : children;

    _.set(mappedById[parentId], 'nestedFields', nestedFields);
  });

  const tree = _.get(groupedByParents, 'null', []);

  return _.isFunction(formatTreeItems) ? formatTreeItems(tree) : tree;
};

// BE goes to another criteria approach and sends another reponse structure (like Tree with another named props). The easiest way till FE doesn't accept decision to handle it - to format new reponse to prev one.
export const formatReceivedTreeToFlat = (
  descendants,
  { parentCriteriaId = null, companyId = null },
) =>
  descendants.reduce((acc, item) => {
    const { descendants, id, expression } = item;

    acc = {
      ...acc,
      [id]: {
        ..._.omit(item, ['descendants', 'id', 'expression']),
        criteriaId: id,
        parentCriteriaId,
        expression: expression.value,
        userFriendlyExpression: expression.userFriendly,
        companyId,
      },
      ...formatReceivedTreeToFlat(descendants, { parentCriteriaId: id, companyId }),
    };

    return acc;
  }, {});
